import React from 'react';
import logo from '../../assets/img/tgle-ch-dark.png';


const  CapitalHumano = ()=>{
    return <div style={{ textAlign:'center', paddingTop:'50px' }}><img alt='logo' src={logo } style={{maxWidth:'80%'}} /></div>;
};

export default CapitalHumano;
